module.exports = __webpack_public_path__ + "static/media/info.a5cb09ca.png";